import React, { useState } from "react";
import "./UsersReport.css";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { CheckIcon } from "@heroicons/react/solid";
import AdminTabs from "../Admin/AdminTabs";

const when = (d) =>
  d ? new Date(d).toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "";
const day = (d) => (d ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "");
const Tick = ({ on }) => (on ? <CheckIcon className="h-5 w-5 text-green-500" aria-label="Yes" /> : null);

/** Mobstr staff: every active user across all customers. */
const UsersReport = ({ userLoggedIn }) => {
  const [show, setShow] = useState(false);

  // Only fetched once the report is revealed, so nothing loads on a visible screen by accident.
  const adminUsers = useQuery(["adminUsers"], () => axios.get(`${process.env.REACT_APP_API_ROOT}/admin/users`), { enabled: show });

  return (
    <>
      <AdminTabs userLoggedIn={userLoggedIn} />
      <p className="text-red-700 mt-3 mb-3 font-bold">
        Caution! This is the Admin Section. Check surrounding security, and screen security, then click below to show the users report.
      </p>
      {!show && (
        <button
          onClick={() => setShow(true)}
          type="button"
          className="text-white bg-red-600 font-medium rounded text-sm w-full sm:w-auto px-5 py-2.5 text-center uppercase"
        >
          Show Users Report
        </button>
      )}

      {show && (
        <div className="mt-6 w-full overflow-x-auto">
          {adminUsers.isLoading && <p className="text-gray-500">Loading…</p>}
          {adminUsers.isError && <p className="text-red-600">Couldn't load the users report.</p>}
          {adminUsers.data && (
            <table className="w-full text-sm bg-white shadow-md rounded mb-4">
              <thead>
                <tr className="border-b text-left">
                  <th className="p-3">ID</th>
                  <th className="p-3">Email</th>
                  <th className="p-3">Organisation</th>
                  <th className="p-3">Invited</th>
                  <th className="p-3">Accepted</th>
                  <th className="p-3">Last login</th>
                  <th className="p-3">Last active</th>
                  <th className="p-3">Apps</th>
                  <th className="p-3">Limit</th>
                  <th className="p-3">Trial expiry</th>
                  <th className="p-3">Admin</th>
                  <th className="p-3">MDM</th>
                  <th className="p-3">Notes</th>
                </tr>
              </thead>
              <tbody>
                {adminUsers.data.data.map((user) => (
                  <tr className="border-b hover:bg-orange-100 bg-gray-50" key={user.id}>
                    <td className="p-3">{user.id}</td>
                    <td className="p-3 break-words">{user.email}</td>
                    <td className="p-3 break-words">{user.organisation}</td>
                    <td className="p-3 whitespace-nowrap">{day(user.createdAt)}</td>
                    <td className="p-3"><Tick on={user.isVerified} /></td>
                    <td className="p-3 whitespace-nowrap">{when(user.lastLogin)}</td>
                    <td className="p-3 whitespace-nowrap">{when(user.lastActive)}</td>
                    <td className="p-3">{user.appCount}</td>
                    <td className="p-3">{user.appLimit}</td>
                    <td className="p-3 whitespace-nowrap">{day(user.trialExpiry)}</td>
                    <td className="p-3"><Tick on={user.isParentAdmin} /></td>
                    <td className="p-3"><Tick on={user.hasMdm} /></td>
                    <td className="p-3 break-words">{user.notes}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </>
  );
};

export default UsersReport;
